import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createOutputStream = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createOutputStream, { input: object })
    );
    return response.data.createOutputStream;
  } catch (error) {
    console.error("Error creating OutputStream:", error);
    throw error;
  }
};

const updateOutputStream = async (id, args) => {
  try {
    // First, fetch the current version of the OutputStream
    const getOutputStreamResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getOutputStream, { id })
    );
    const currentOutputStream = getOutputStreamResponse.data.getOutputStream;

    // Prepare the update input
    const updateInput = { id, _version: currentOutputStream._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateOutputStream, { input: updateInput })
    );
    return response.data.updateOutputStream;
  } catch (error) {
    console.error("Error updating OutputStream:", error);
    throw error;
  }
};

const deleteOutputStream = async (id) => {
  try {
    // First, fetch the current version of the OutputStream
    const getOutputStreamResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getOutputStream, { id })
    );
    const currentOutputStream = getOutputStreamResponse.data.getOutputStream;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteOutputStream, {
        input: { id, _version: currentOutputStream._version },
      })
    );
    return response.data.deleteOutputStream;
  } catch (error) {
    console.error("Error deleting OutputStream:", error);
    throw error;
  }
};

export default {
  createOutputStream,
  updateOutputStream,
  deleteOutputStream,
};
